import { isMobile, isTablet, storeInLocal } from '../../services/shared';
import 'react-tabs/style/react-tabs.css';
import { Collapse } from 'antd';


import "./CarSpecs.scss"
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const CarSpecs = ({car })=>{
    return (
        <div className="car-specs">
            {
                !isMobile() ?
                <>
                <Tabs onSelect={(i,l,e) => {
                    if(i != l){
                        window.dataLayer?.push({
                            'event' : e.target.innerText,
                            'event_make': 'Chevrolet',
                            'event_model': 'Silverado 1500',
                            'event_year': '2021',
                            'event_category': 'Tab selection'
                        })
                    }
                }}>
                    <TabList style={{borderColor: 'rgba(234, 241, 249, 0.7)'}}>
                        <Tab style={{borderColor: 'rgba(234, 241, 249, 0.7)'}}>Performance</Tab>
                        <Tab style={{borderColor: 'rgba(234, 241, 249, 0.7)'}}>Engine</Tab>
                        <Tab style={{borderColor: 'rgba(234, 241, 249, 0.7)'}}>Mechanical</Tab>
                        <Tab style={{borderColor: 'rgba(234, 241, 249, 0.7)'}}>Brakes</Tab>
                        <Tab style={{borderColor: 'rgba(234, 241, 249, 0.7)'}}>Safety</Tab>
                        <Tab style={{borderColor: 'rgba(234, 241, 249, 0.7)'}}>Interior</Tab>
                        <Tab style={{borderColor: 'rgba(234, 241, 249, 0.7)'}}>Exterior</Tab>
                    </TabList>

                    <TabPanel>
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        {/* <div className="label">Transmission</div> */}
                                        <div className="value" style={{fontWeight: 'normal'}}>The Chevy Silverado 1500 LT model is a light duty truck with heavy 
                                            duty features and function. For drivers who need a capable, sturdy truck that can easily 
                                            double as a comfortable and functional field office, the Silverado will have wide appeal. 
                                            The base 2.7-liter turbo inline-four has 310 horsepower and 348 pound-feet of torque with 
                                            a max towing capacity of 9,400 pounds.
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Transmission</div>
                                        <div className="value">6-Speed A/T , A/T , 8-Speed A/T</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Drive Train</div>
                                        <div className="value">Rear Wheel Drive</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Engine Type</div>
                                        <div className="value">4 Cylinder Engine , V6 Cylinder Engine , 8 Cylinder Engine , Turbocharged</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Displacement</div>
                                        <div className="value">5.3L/325 , 6.2L/376 , 2.7L/166 , 4.3L/262</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Fuel Tank Capacity</div>
                                        <div className="value">28.3 gal</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">HorsePower @ RPM</div>
                                        <div className="value">355 @ 5600 , 420 @ 5600 , 310 @ 5600 , 285 @ 5300</div>
                                    </div>
                                </li>
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Torque @ RPM</div>
                                        <div className="value">383 @ 4100 , 460 @ 4100 , 348 @ 1500 , 305 @ 3900</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Suspension Type - Front</div>
                                        <div className="value">Independent</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Suspension Type - Rear</div>
                                        <div className="value">Solid Axle</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Steering Type</div>
                                        <div className="value">Electric Rack & Pinion</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Steering Turning Diameter</div>
                                        <div className="value">44.6 ft</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Brakes Type</div>
                                        <div className="value">ABS , 4-Wheel Disc Brakes</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Front Leg Room</div>
                                        <div className="value">44.53 in</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Disc - Rear</div>
                                        <div className="value">Yes</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Disc - Front</div>
                                        <div className="value">Yes</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Air Bag - Frontal</div>
                                        <div className="value">Driver Air Bag , Passenger Air Bag , Passenger Air Bag Sensor</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Air Bag - Side</div>
                                        <div className="value">Front Side Air Bag , Front Head Air Bag , Rear Head Air Bag</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Locks</div>
                                        <div className="value">Keyless Entry , Power Door Locks</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Convenience</div>
                                        <div className="value">Cruise Control , Adjustable Steering Wheel , Fog Lamps , Steering Wheel Audio Controls , Power Outlet , Rear Parking Aid , Telematics , Back-Up Camera , Requires Subscription</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Seats</div>
                                        <div className="value">Power Driver Seat , Split Bench Seat , Driver Adjustable Lumbar</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Air Conditioning</div>
                                        <div className="value">Yes</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Mirrors</div>
                                        <div className="value">Heated Mirrors , Power Mirror(s) , Auto-Dimming Rearview Mirror</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Entertainment</div>
                                        <div className="value">AM/FM Stereo , Satellite Radio , MP3 Player , Auxiliary Audio Input , WiFi Hotspot , Smart Device Integration</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Body Style</div>
                                        <div className="value">Regular Cab Chassis Cab , Regular Cab Pickup</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Height</div>
                                        <div className="value">75.63 in</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Wheel Base</div>
                                        <div className="value">139.56 in</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Color</div>
                                        <div className="value">Black , Northsky Blue Metallic , Oxford Brown Metallic , Red Hot , Satin Steel Metallic , Shadow Gray Metallic , Silver Ice Metallic , Special Exterior Color , Summit White</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </TabPanel>
                </Tabs>
                </>
                :
                <Collapse accordion expandIconPosition="right" ghost= "true" defaultActiveKey={['Performance']} expandIcon = {({ isActive }) => isActive ? <div className="accordion-button">-</div> : <div className="accordion-button">+</div>} onChange={(tabName) => { 
                        window.dataLayer?.push({
                            'event': tabName,
                            'event_make': 'Chevrolet',
                            'event_model': 'Silverado 1500',
                            'event_year': '2021',
                            'event_category': 'Tab selection'
                        })}}>
                    <Collapse.Panel header="Performance" key="Performance">
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        {/* <div className="label">Transmission</div> */}
                                        <div className="value" style={{fontWeight: 'normal'}}>The Chevy Silverado 1500 LT model is a light duty truck with heavy 
                                            duty features and function. For drivers who need a capable, sturdy truck that can easily 
                                            double as a comfortable and functional field office, the Silverado will have wide appeal. 
                                            The base 2.7-liter turbo inline-four has 310 horsepower and 348 pound-feet of torque with 
                                            a max towing capacity of 9,400 pounds.
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Transmission</div>
                                        <div className="value">6-Speed A/T , A/T , 8-Speed A/T</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Drive Train</div>
                                        <div className="value">Rear Wheel Drive</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Collapse.Panel>
                    <Collapse.Panel header="Engine" key="Engine">
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Engine Type</div>
                                        <div className="value">4 Cylinder Engine , V6 Cylinder Engine , 8 Cylinder Engine , Turbocharged</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Displacement</div>
                                        <div className="value">5.3L/325 , 6.2L/376 , 2.7L/166 , 4.3L/262</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Fuel Tank Capacity</div>
                                        <div className="value">28.3 gal</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">HorsePower @ RPM</div>
                                        <div className="value">355 @ 5600 , 420 @ 5600 , 310 @ 5600 , 285 @ 5300</div>
                                    </div>
                                </li>
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Torque @ RPM</div>
                                        <div className="value">383 @ 4100 , 460 @ 4100 , 348 @ 1500 , 305 @ 3900</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Collapse.Panel>
                    <Collapse.Panel header="Mechanical" key="Mechanical">
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Suspension Type - Front</div>
                                        <div className="value">Independent</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Suspension Type - Rear</div>
                                        <div className="value">Solid Axle</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Steering Type</div>
                                        <div className="value">Electric Rack & Pinion</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Steering Turning Diameter</div>
                                        <div className="value">44.6 ft</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Collapse.Panel>
                    <Collapse.Panel header="Brakes" key="Brakes">
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Brakes Type</div>
                                        <div className="value">ABS , 4-Wheel Disc Brakes</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Front Leg Room</div>
                                        <div className="value">44.53 in</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Disc - Rear</div>
                                        <div className="value">Yes</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Disc - Front</div>
                                        <div className="value">Yes</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Collapse.Panel>
                    <Collapse.Panel header="Safety" key="Safety">
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Air Bag - Frontal</div>
                                        <div className="value">Driver Air Bag , Passenger Air Bag , Passenger Air Bag Sensor</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Air Bag - Side</div>
                                        <div className="value">Front Side Air Bag , Front Head Air Bag , Rear Head Air Bag</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Locks</div>
                                        <div className="value">Keyless Entry , Power Door Locks</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Convenience</div>
                                        <div className="value">Cruise Control , Adjustable Steering Wheel , Fog Lamps , Steering Wheel Audio Controls , Power Outlet , Rear Parking Aid , Telematics , Back-Up Camera , Requires Subscription</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Collapse.Panel>
                    <Collapse.Panel header="Interior" key="Interior">
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Seats</div>
                                        <div className="value">Power Driver Seat , Split Bench Seat , Driver Adjustable Lumbar</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Air Conditioning</div>
                                        <div className="value">Yes</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Mirrors</div>
                                        <div className="value">Heated Mirrors , Power Mirror(s) , Auto-Dimming Rearview Mirror</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Entertainment</div>
                                        <div className="value">AM/FM Stereo , Satellite Radio , MP3 Player , Auxiliary Audio Input , WiFi Hotspot , Smart Device Integration</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Collapse.Panel>
                    <Collapse.Panel header="Exterior" key="Exterior">
                        <div className="car-specs-container">
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Body Style</div>
                                        <div className="value">Regular Cab Chassis Cab , Regular Cab Pickup</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Height</div>
                                        <div className="value">75.63 in</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Wheel Base</div>
                                        <div className="value">139.56 in</div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="flex">
                                <li className="flex flex-1" >
                                    <div>
                                        <div className="label">Color</div>
                                        <div className="value">Black , Northsky Blue Metallic , Oxford Brown Metallic , Red Hot , Satin Steel Metallic , Shadow Gray Metallic , Silver Ice Metallic , Special Exterior Color , Summit White</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Collapse.Panel>
                    
                </Collapse>

            }
        </div>
        
        
    )
}

export default CarSpecs;